var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full mx-auto p-6 bg-white shadow rounded"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold mb-6"
  }, [_vm._v("Update Career")]), _c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-6"
  }, [_c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Title *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.title,
      expression: "form.title"
    }],
    staticClass: "w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-400 focus:border-blue-400",
    attrs: {
      "type": "text",
      "placeholder": "Enter job title"
    },
    domProps: {
      "value": _vm.form.title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "title", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Location *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.location,
      expression: "form.location"
    }],
    staticClass: "w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-400 focus:border-blue-400",
    attrs: {
      "type": "text",
      "placeholder": "e.g. Jakarta, Indonesia"
    },
    domProps: {
      "value": _vm.form.location
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "location", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Work Type *")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.work_type,
      expression: "form.work_type"
    }],
    staticClass: "w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-400 focus:border-blue-400",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.form, "work_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select work type")]), _c('option', {
    attrs: {
      "value": "Remote"
    }
  }, [_vm._v("Remote")]), _c('option', {
    attrs: {
      "value": "Hybrid"
    }
  }, [_vm._v("Hybrid")]), _c('option', {
    attrs: {
      "value": "Onsite"
    }
  }, [_vm._v("Onsite")])])]), _c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Rentang Tanggal *")]), _c('div', {
    staticClass: "date-range relative text-xs"
  }, [_c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 z-1"
  }, [_c('Calendar', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('date-range-picker', {
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy',
        separator: ' - '
      },
      "showDropdowns": false,
      "timePicker": true,
      "timePicker24Hour": true,
      "ranges": false
    },
    on: {
      "update": _vm.handleDateRangeChange
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1)])]), _c('div', {
    staticClass: "mt-6"
  }, [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Description *")]), _c('div', {
    staticClass: "border border-gray-300 rounded"
  }, [_c('TextEditorComponents', {
    model: {
      value: _vm.form.description,
      callback: function ($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1)]), _c('div', {
    staticClass: "flex gap-3 mt-6"
  }, [_c('button', {
    staticClass: "bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded shadow transition duration-200",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" Update Career ")]), _c('button', {
    staticClass: "bg-gray-300 hover:bg-gray-400 text-gray-700 font-bold py-2 px-6 rounded shadow transition duration-200",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/career');
      }
    }
  }, [_vm._v(" Cancel ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }